import React from 'react';

const NotFoundPage = () => (
  <>
    <div>Oops, no encontramos esta página.</div>
  </>
);

export default NotFoundPage;
